import { CRAWLER_CATEGORIES } from '~features/crawler-filter';

const TOOLTIPS = {
  [CRAWLER_CATEGORIES.grouped]: "Low-volume crawl categories that didn't make it to the top 5, grouped together.",
  [CRAWLER_CATEGORIES.unknown]:
    'Includes thousands of lesser-known crawlers and bots, with each contributing less <strong>than 0.5% of total traffic</strong>. To keep things simple, we group them here.',
  uncached: 'Pages not served from cache but rendered live with 200(OK) status code.',
};

export default TOOLTIPS;
